import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { GotoCratdialogComponent } from '../goto-cratdialog/goto-cratdialog.component';
import { CONST_AWS_API } from 'src/app/core/constants';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { environment } from 'src/environments/environment';
import { API } from 'aws-amplify';
import { CommanSubscribeService } from 'src/app/core/services/comman-subscribe.service';
import { ToastrService } from 'ngx-toastr';
import * as moment from 'moment';
import { UserService } from 'src/app/core/services/user.service';
import { MERCH_API } from 'src/app/core/constants';
import { AppService } from 'src/app/core/services/app.service';
import { listenerCount } from 'stream';
import { AppPaymentTVService } from 'src/app/core/services/app-payment-tv.service';
import { combineLatest, observable, Subscription } from 'rxjs';
import { skip } from 'rxjs/operators';
import { StorageService } from 'src/app/core/services/storage.service';
import { ConsumerSignInComponent } from '../../landing-pages/consumer/consumer-sign-in/consumer-sign-in.component';
import { UtilityService } from 'src/app/core/services/utility.service';
import { or } from '@rxweb/reactive-form-validators';
import { time, timeStamp } from 'console';



@Component({
  selector: 'app-overview-product',
  templateUrl: './overview-product.component.html',
  styleUrls: ['./overview-product.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class OverviewProductComponent implements OnInit {

  counter = 1;
  userInfo: any;
  wishlist_status: any;
  addWishListData: any;
  itemLists: any;
  listProductId: any;
  organizationId: any;
  collectionId: any;
  productId: any;
  brandName: any;

  saleText: any;

  collectionName: any;
  productName: any;
  productDescriptionShort: any;
  productDescriptionLong: any;
  productDescriptionTrunc: any;
  isReadMore: boolean = false;

  saleStartDate: any;
  saleEndDate: any;
  saleStartOrEndDate: any
  productColor: any;
  productSize: any;
  productImgs: any;
  productImgsLength: any = 0;
  productPrice: any;
  productCurrency: any;
  productQuantity: any;
  prodAttributes: any;
  selectedProdAttributes: any;
  productShippingDetails: any;
  finalProductDetails: any;
  isGoToCartActive: boolean = false;
  justAddedToCart: boolean = false;
  private justAddedTimer: any;
  //timer vars
  timezoneVal
  endDate: any;
  startDate: any;

  todayDate: any;
  totalSeconds: number = 0; // Difference between todays date and sales end date
  days: number = 0;
  hours: number = 0;
  minutes: number = 0;
  seconds: number = 0;
  displayTime: any;
  showTimer: boolean = false;
  totalSecondsSaleStart: number;
  uniqueAttributes: unknown[];

  selectedProdQuantity: any = 1;
  selectedProdAtributes: any;
  productInventry: any;
  prodLimitedInventry: any;
  cartProductsList: any;
  mainImg: any;
  currentLocation: any;
  isShippingAvl: boolean = true;
  cartId: any;
  getCurrency: any;
  currencyInfoSubscription: Subscription;
  userInfoSubscription: Subscription;
  routeChangeSubscription: Subscription;
  hideBtns: boolean = false;
  featureChecked: any = false;
  myCollectionId: any;
  channelName: string;
  settingsData: any = {};
  settingsDataSubscription: Subscription;
  networkGroupId : any;
  constructor(
    public dialog: MatDialog,
    private router: Router,
    private ngxLoader: NgxUiLoaderService,
    private commonSubscribeService: CommanSubscribeService,
    private toaster: ToastrService,
    private userService: UserService,
    private appService: AppService,
    private appPaymentService: AppPaymentTVService,
    private activatedRoute: ActivatedRoute,
    private storageService: StorageService,
    private utilityService: UtilityService,
    private route: ActivatedRoute,

  ) { }
  ngOnInit(): void {
    this.userInfo = this.commonSubscribeService.userInfo;
    this.userInfoSubscription = this.commonSubscribeService.getUserInfo().subscribe(response => {
      this.userInfo = response;
    });
    this.networkGroupId = this.commonSubscribeService.activeGroupId;
    this.timezoneVal = this.userService.getTimezone();
    this.todayDate = moment.utc(new Date(), "YYYY-MM-DD HH:mm:ss").tz(this.timezoneVal).valueOf();
    this.storageService.setItem("product_info", { collection_id: this.activatedRoute.snapshot.params.collection_id });
    this.productId = this.activatedRoute.snapshot.params.product_id;
    // this.collectionId = this.activatedRoute.snapshot.params.collection_id;
    this.getProductDetails();
    this.getWishListData();
    // this.currentLocation = this.commonSubscribeService.locationInfo;
    let locInfo = this.commonSubscribeService.locationInfo;
    this.currentLocation = locInfo && Object.keys(locInfo).length > 0 ? locInfo : this.storageService.getItem('current_location');
    if (!this.currentLocation || Object.keys(this.currentLocation).length == 0) {
      this.commonSubscribeService.getCurrentLocation((val: any, json: any) => {
        if (val == "fail") {
          this.currentLocation = {};
        } else {
          this.currentLocation = json;
        }
        this.getCurrency = this.getCurrency ? this.getCurrency : this.currentLocation["currency"]["code"];
      });
    } else if (this.currentLocation && Object.keys(this.currentLocation).length > 0) {
      this.getCurrency = this.getCurrency ? this.getCurrency : this.currentLocation["currency"]["code"];
    }
    this.settingsDataSubscription = this.commonSubscribeService.getICWebpageThemeSettings().subscribe(async (response) => {
      this.settingsData = response;
    });
    this.settingsData = this.commonSubscribeService.icWebpageSettingsData;
    this.currencyInfoSubscription = this.commonSubscribeService.getCurrencyInfo().subscribe(response => {
      if (response) {
        this.getCurrency = this.storageService.getItem('currency');
        this.getProductDetails();
      }
    });

    let paramas = this.activatedRoute.snapshot.params;
    this.myCollectionId = paramas.collection_id
    this.channelName = this.route.parent.snapshot.params['channelName'];

    // Opening another product (e.g. from the cart) while already on this page reuses the component.
    this.routeChangeSubscription = combineLatest([this.activatedRoute.paramMap, this.activatedRoute.queryParamMap])
      .pipe(skip(1))
      .subscribe(([params]) => {
        this.productId = params.get('product_id');
        this.myCollectionId = params.get('collection_id');
        // These are only assigned when the new product has them, so clear the previous product's values.
        this.prodAttributes = null;
        this.productImgs = [];
        this.productImgsLength = 0;
        this.mainImg = null;
        this.getProductDetails();
        this.getWishListData();
      });


  }

  isMerchandiseFlow(): boolean {
  return this.router.url.includes('/merchandise');
  }

  openDialog() {
    const dialogRef = this.dialog.open(GotoCratdialogComponent, {
      panelClass: 'app-signout-confirmation',
      disableClose: true,
      data: this.finalProductDetails
    });
    dialogRef.afterClosed().subscribe(result => {
      console.log(result);

    });
  }

  addToCart(from?) {
    if (this.userInfo && this.userInfo.access_token) {
      let is_error = false;
      const userId = this.userInfo?.user_first_name + ' ' + this.userInfo?.user_last_name;
      (window as any).umami?.track(`Add to Cart Clicked by - ${userId}`);

      if (from !== 'buynow') {
        const u_payload = {
          actionType: "product",
          metaData: {
            title: "Add to Cart Clicked",
            productId: this.productId,
            orgId: this.organizationId,
            collectionId: this.myCollectionId,
            timeStamp: new Date().toISOString(),
            
          },
          organizationId: this.organizationId || null,
          networkGroupId: this.finalProductDetails?.network_group_id || null,
          clickAction: 'add-to-cart'
        }
        this.commonSubscribeService.sendTriggeredEvent(u_payload);
      }
      if (this.prodAttributes) {
        this.prodAttributes.forEach(prodKeys => {
          let selected = prodKeys.attributesList.filter(attr => attr.is_selected == true)
          if (selected.length == 0) {
            is_error = true
          }
        });
      }

      if (is_error) {
        this.toaster.error("Please select attribute to proceed");
      } else {
        this.finalProductDetails.quantity = this.selectedProdQuantity;

        if (this.prodAttributes) {
          this.finalProductDetails.data.attributes = this.prodAttributes;

        }

        let data = this.finalProductDetails;

        if( !this.networkGroupId) {
          delete data.network_group_id;
        }
        if(this.myCollectionId) {
          data.collection_id = Number(this.myCollectionId);
        }

        this.ngxLoader.start();
        let url = MERCH_API.ADD_TO_CART;

        this.appPaymentService.postRequest(url, data).subscribe(response => {
          this.ngxLoader.stop();

          if (response.status === 0) {

            // this.commonSubscribeService.cartRefreshSubject.next({ 'is_refresh': true });
            this.commonSubscribeService.getCartProdCountApiCallSubject.next(true);


            if (from == "buynow") {

              const currentUrl = this.router.url;

              // detect merchandise flow
              const isMerchandise = currentUrl.includes('/merchandise');

              this.router.navigate([
                isMerchandise
                  ? `${this.commonSubscribeService.getChannelBasePath(this.channelName)}/merchandise/product-cart/${response.cart_id}`
                  : `/network-market/product-cart/${response.cart_id}`
              ]);

            } else {

              this.isGoToCartActive = true;
              this.cartId = response.cart_id;
              this.justAddedToCart = true;
              clearTimeout(this.justAddedTimer);
              this.justAddedTimer = setTimeout(() => this.justAddedToCart = false, 2000);


              // this.openCheckoutDialog(response.cart_id);

            }
            this.toaster.success(response.message);


          } else if (response.status === 1) {

            this.toaster.error(response.message)

          }
        }, error => {
          this.ngxLoader.stop();
          this.toaster.error(error)
        });

      }
    } else {
      this.requireLogin();
    }

  }

  requireLogin() {
    this.storageService.setItem('skipRedirection', 'yes');
    const dialogRef = this.dialog.open(ConsumerSignInComponent, {
      maxWidth: "400px",
      panelClass: "app-consumer-sign-in",
      disableClose: true,
      data: {}
    });
    dialogRef.afterClosed().subscribe(result => {
      console.log(result);
      if (result == "success") {
        this.userInfo = this.commonSubscribeService.userInfo;
      }
    });
  }
  goBack() {
    let paramas = this.activatedRoute.snapshot.params;
    (window as any).umami?.track(`Going back from product- ${this.productId} - ${this.productName}`, {
      productName: this.productName,
      userId: this.userInfo?.user_first_name + ' ' + this.userInfo?.user_last_name,
    });
    const data = {
      actionType: "product",
      metaData: {
        title: `Going back from product- ${this.productId} - ${this.productName}`,
        productId: this.productId,
        orgId: this.organizationId,
        collectionId: this.myCollectionId,
        timeStamp: new Date().toISOString()
      },
      organizationId: this.organizationId || null,
      networkGroupId: this.finalProductDetails?.network_group_id || null,
      clickAction: `product`
    }
    this.commonSubscribeService.sendTriggeredEvent(data);
    if (paramas.collection_id != 0){
      if(this.isMerchandiseFlow()){
        this.router.navigate([this.commonSubscribeService.getChannelBasePath(this.channelName) + `/merchandise/product-marketplace/${paramas.collection_id}`]);
      }else{
        this.router.navigateByUrl('/network-market/product-marketplace/' + paramas.collection_id)
      }
    }
    else{
      if (this.isMerchandiseFlow()){
        this.router.navigate([this.commonSubscribeService.getChannelBasePath(this.channelName) + '/merchandise/merch-list']);
      }
      else{
        this.router.navigateByUrl('/network-market/market')
      }
    }
  }

  goToCart() {
    const userId = this.userInfo?.user_first_name + ' ' + this.userInfo?.user_last_name;
    (window as any).umami?.track(`Go To Cart Clicked by - ${userId}`, {
      productName: this.productName
    });
    const data = {
      actionType: "product",
      metaData: {
        title: `Go To Cart Clicked - ${this.productName} and id is ${this.productId}`,
        productId: this.productId,
        orgId: this.organizationId,
        collectionId: this.myCollectionId,
        timeStamp: new Date().toISOString()
      },
      organizationId: this.organizationId || null,
      networkGroupId: this.finalProductDetails?.network_group_id || null,
      clickAction: 'add-to-cart'
    }
    this.commonSubscribeService.sendTriggeredEvent(data);
    const currentUrl = this.router.url;

  // detect merchandise flow
    const isMerchandise = currentUrl.includes('/merchandise');

    // decide base route
    const base = isMerchandise
      ? `${this.commonSubscribeService.getChannelBasePath(this.channelName)}/merchandise`
      : '/network-market';

    const extras = this.channelName
      ? { queryParams: { orgId: this.organizationId } }
      : {};

    // navigate
    this.router.navigate([`${base}/product-cart/${this.cartId}`], extras);
  }

  changeImg(imgUrl) {
    this.mainImg = imgUrl
  }
  removeBrokenImg(imgUrl) {
    this.productImgs = this.productImgs.filter(url => url !== imgUrl);
    this.productImgsLength = this.productImgs.length;
    if (this.mainImg === imgUrl) {
      this.mainImg = this.productImgs[0];
    }
  }
  buyNow() {
    if (this.userInfo && this.userInfo.access_token) {
      const userId = this.userInfo?.user_first_name + ' ' + this.userInfo?.user_last_name;
      (window as any).umami?.track(`Buy Now Clicked by - ${userId}`, {
        productName: this.productName
      });
      const data = {
        actionType: "product",
        metaData: {
          title: `Buy Now Clicked - ${this.productName} and id is ${this.productId}`,
          productId: this.productId,
          orgId: this.organizationId,
          collectionId: this.myCollectionId,
          timeStamp: new Date().toISOString()
        },
        organizationId: this.organizationId || null,
        networkGroupId: this.finalProductDetails?.network_group_id || null,
        clickAction: `product-buy`
      }
      this.commonSubscribeService.sendTriggeredEvent(data);
      this.addToCart("buynow")
    } else {
      this.requireLogin();
    }
    // this.router.navigateByUrl('/network-market/product-shipping') 
  }

  increment() {
    (window as any).umami?.track(`Quantity plus Clicked - Product ID: ${this.productId}`, {
      productName: this.productName,
      userId: this.userInfo?.user_first_name + ' ' + this.userInfo?.user_last_name,
    });
    const data = {
      actionType: "product",
      metaData: {
        title: `Quantity plus Clicked - ${this.productId} - ${this.productName}`,
        productId: this.productId,
        orgId: this.organizationId,
        collectionId: this.myCollectionId,
        timeStamp: new Date().toISOString()
      },
      organizationId: this.organizationId || null,
      networkGroupId: this.finalProductDetails?.network_group_id || null,
      clickAction: `product`
    }
    this.commonSubscribeService.sendTriggeredEvent(data);
    this.counter++;

    if (this.prodLimitedInventry && this.productInventry < this.counter) {

      this.toaster.info("Only " + this.productInventry + " products available");
      this.counter = this.productInventry;

    } else {

      this.selectedProdQuantity = this.counter;

    }


  }

  decrement() {
    (window as any).umami?.track(`Quantity minus Clicked - Product ID: ${this.productId}`, {
      productName: this.productName,
      userId: this.userInfo?.user_first_name + ' ' + this.userInfo?.user_last_name,
    });
    const data = {
      actionType: "product",
      metaData: {
        title: `Quantity minus Clicked - ${this.productId} - ${this.productName}`,
        productId: this.productId,
        orgId: this.organizationId,
        collectionId: this.myCollectionId,
        timeStamp: new Date().toISOString()
      },
      organizationId: this.organizationId || null,
      networkGroupId: this.finalProductDetails?.network_group_id || null,
      clickAction: `product`
    }
    this.commonSubscribeService.sendTriggeredEvent(data);
    this.counter--;
    if (this.counter < 1) {
      this.counter = 1;
    }
    this.counter;
    this.selectedProdQuantity = this.counter
  }

  isReadLess: boolean = false;
  readMoreLess(read) {
    this.isReadMore = false;
    if (read == "more") {

      this.productDescriptionTrunc = this.productDescriptionLong;
      this.isReadMore = false;

    } else if (read == "less") {

      if (this.productDescriptionLong.length >= 120) {


        this.productDescriptionTrunc = this.productDescriptionLong.substring(0, 120) + "...";
        this.isReadMore = true;
        if (this.isReadMore)
          this.isReadLess = true;

      } else {
        this.productDescriptionTrunc = this.productDescriptionLong
      }
    }
  }

  startTimer() {
    if (this.displayTime) {
      clearInterval(this.displayTime);
    }

    this.displayTime = setInterval(() => {


      if (this.totalSeconds > 0) {
        this.days = Math.floor(this.totalSeconds / 86400000);
        this.hours = Math.floor((this.totalSeconds - (this.days * 86400000)) / 3600000);
        this.minutes = Math.floor((this.totalSeconds - ((this.days * 86400000) + this.hours * 3600000)) / 60000);
        this.seconds = Math.floor((this.totalSeconds - ((this.days * 86400000) + (this.hours * 3600000) + (this.minutes * 60000))) / 1000);
        this.totalSeconds = this.totalSeconds - 1000;
      } else {
        this.days = 0;
        this.hours = 0;
        this.minutes = 0;
        this.seconds = 0;
      }
    }, 1000)



  }


  gotoWishList() {
    if (this.userInfo && this.userInfo.access_token) {
      const u_payload = {
        actionType: "product",
        metaData: {
          title: `Product added to wishlist - ${this.productId} - ${this.productName}`,
          productId: this.productId,
          orgId: this.organizationId,
          collectionId: this.myCollectionId,
          timeStamp: new Date().toISOString()
        },
        organizationId: this.organizationId || null,
        networkGroupId: this.finalProductDetails?.network_group_id || null,
        clickAction: `wishlist-add`
      }
      this.commonSubscribeService.sendTriggeredEvent(u_payload);
      let data = {
        headers: {
          "Content-Type": "application/json",
          "x-api-key": environment.AWS_Cognito.X_Api_Key,
          "Authorization": `Bearer ${this.userInfo.access_token}`,
        },
        response: true,
        body: {
          "type": "add",
          "product_id": this.listProductId,
          "collection_id": this.collectionId,
          "organization_id": this.organizationId,
        }
      }
      this.ngxLoader.start();
      API.post(environment.AWS_Cognito.apiName, CONST_AWS_API.WISH_LIST, data).then(response => {
        this.ngxLoader.stop();
        if (response.data.statusCode === '200') {
          (window as any).umami?.track(`Added to Wishlist - Product ID: ${this.productId}`, {
            productName: this.productName,
            userId: this.userInfo?.user_first_name + ' ' + this.userInfo?.user_last_name,
          });
          const data = {
            actionType: "product",
            metaData: {
              title: `Added to Wishlist - ${this.productId} - ${this.productName}`,
              timeStamp: new Date().toISOString()
            },
            organizationId: this.organizationId || null,
            networkGroupId: this.finalProductDetails?.network_group_id || null,
          }
          this.commonSubscribeService.sendTriggeredEvent(data);
          this.addWishListData = response.data.result;
          this.wishlist_status = this.addWishListData.wishlist_status;
          this.toaster.success(response.data.message);
        }
      }).catch(error => {
        this.ngxLoader.stop();
      });
    } else {
      this.requireLogin();
    }

  }
  goOutWishList() {
    if (this.userInfo && this.userInfo.access_token) {
      const u_payload = {
        actionType: "product",
        metaData: {
          title: `Product removed from wishlist - ${this.productId} - ${this.productName}`,
          productId: this.productId,
          orgId: this.organizationId,
          collectionId: this.myCollectionId,
          timeStamp: new Date().toISOString()
        },
        organizationId: this.organizationId || null,
        networkGroupId: this.finalProductDetails?.network_group_id || null,
        clickAction: `wishlist-remove`
      }
      this.commonSubscribeService.sendTriggeredEvent(u_payload);
      let data = {
        headers: {
          "Content-Type": "application/json",
          "x-api-key": environment.AWS_Cognito.X_Api_Key,
          "Authorization": `Bearer ${this.userInfo.access_token}`,
        },
        response: true,
        body: {
          "type": "delete",
          "product_id": this.listProductId,
        }
      }
      this.ngxLoader.start();
      API.post(environment.AWS_Cognito.apiName, CONST_AWS_API.WISH_LIST, data).then(response => {
        this.ngxLoader.stop();
        if (response.data.statusCode === '200') {
          (window as any).umami?.track(`Removed From Wishlist - Product ID: ${this.productId}`, {
            productName: this.productName,
            userId: this.userInfo?.user_first_name + ' ' + this.userInfo?.user_last_name,
          });
          const data = {
            actionType: "product",
            metaData: {
              title: `Removed From Wishlist - ${this.productId} - ${this.productName}`,
              timeStamp: new Date().toISOString()
            },
            organizationId: this.organizationId || null,
            networkGroupId: this.finalProductDetails?.network_group_id || null,
          }
          this.commonSubscribeService.sendTriggeredEvent(data);
          this.wishlist_status = '0';
          this.toaster.success(response.data.message);
        }
      }).catch(error => {
        this.ngxLoader.stop();
      });
    } else {
      this.requireLogin();
    }

  }
  getWishListData() {
    let data = {
      headers: {
        "Content-Type": "application/json",
        "x-api-key": environment.AWS_Cognito.X_Api_Key,
        "Authorization": `Bearer ${this.userInfo.access_token}`,
      },
      response: true,
      body: {
        "type": "get",
        "product_id": this.productId,
      }
    }
    this.ngxLoader.start();
    API.post(environment.AWS_Cognito.apiName, CONST_AWS_API.WISH_LIST, data).then(response => {
      this.ngxLoader.stop();
      if (response.data.statusCode === '200') {
        this.addWishListData = response.data.result;
        for (var product of this.addWishListData) {
          this.itemLists = product.Item;

          this.wishlist_status = this.itemLists.wishlist_status;
          this.listProductId = this.itemLists.product_id;
          this.organizationId = this.itemLists.organization_id;
          this.collectionId = this.itemLists.collection_id;
        }
      }
    }).catch(error => {
      this.ngxLoader.stop();
    });

  }

  selectAttributes(selectedAttr) {
    (window as any).umami?.track(`${selectedAttr.name} ${selectedAttr.value} selected for ${this.productId}`, {
      productName: this.productName,
      userId: this.userInfo?.user_first_name + ' ' + this.userInfo?.user_last_name,
    });
    const data = {
      actionType: "product",
      metaData: {
        title: `${selectedAttr.name} ${selectedAttr.value} selected for ${this.productId}`,
        productId: this.productId,
        orgId: this.organizationId,
        collectionId: this.myCollectionId,
        timeStamp: new Date().toISOString()
      },
      organizationId: this.organizationId || null,
      networkGroupId: this.finalProductDetails?.network_group_id || null,
      clickAction: 'attribute-select'
    }
    this.commonSubscribeService.sendTriggeredEvent(data);
    this.selectedProdAttributes = selectedAttr;
    this.prodAttributes.forEach(element => {

      if (element.attribute_name == selectedAttr.name) {

        element.attributesList.forEach(att => {

          if (att.value_id == selectedAttr.value_id) {

            att['is_selected'] = true;
            element['selected_attr'] = selectedAttr.value;
          } else {
            att['is_selected'] = false;

          }
        })
      }


    });




  }
  getProductDetails() {
    let code = this.currentLocation && this.currentLocation.currency ? this.currentLocation.currency.code : '';
    this.getCurrency = this.getCurrency ? this.getCurrency : this.storageService.getItem('currency');
    let data = {
      headers: {
        "Content-Type": "application/json",
        "x-api-key": environment.AWS_Cognito.X_Api_Key,
        "Authorization": `Bearer ${this.userInfo.access_token}`
      },
      response: true,
      body: {
        "product_id": this.productId,
        "currency": this.getCurrency ? this.getCurrency : this.storageService.getItem('currency'),
      }

    }


    let url = CONST_AWS_API.MERCH_PROD_DETAILS

    API.post(environment.AWS_Cognito.apiName, url, data)
      .then((response) => {

        response = response.data;

        if (response.statusCode === "200") {

          let prodDetails = response.Data;
          if (response?.Data?.length > 0 && !this.featureChecked) {
            const organizationId = response.Data[0].organization_id;
            this.utilityService.loadOrganizationFeatures(organizationId).then((featureList) => {
              if (!this.utilityService.isActiveFeature(featureList, 'merchandise')) {
                this.featureChecked = true;
                this.toaster.warning('Merchandise feature is not accessible to this network');
                this.router.navigateByUrl('/');
              }
            })
          }
          let prodDetailsObj = prodDetails[0];

          this.finalProductDetails = prodDetailsObj;

          this.finalProductDetails.product_id = prodDetailsObj.id;


          this.finalProductDetails.collection_id = this.collectionId;
          this.collectionId = prodDetailsObj.collection_ids;

          this.listProductId = prodDetailsObj.id;
          this.brandName = prodDetailsObj.data.brand_name;
          this.organizationId = prodDetailsObj.organization_id
          this.productId = prodDetailsObj.id
          this.finalProductDetails.network_group_id = prodDetailsObj?.data?.network_group_id;
          this.finalProductDetails.data.network_group_id = prodDetailsObj?.data?.network_group_id;

          this.productName = prodDetailsObj.data.name;
          this.productDescriptionShort = prodDetailsObj.data.short_description;
          this.productDescriptionLong = prodDetailsObj.data.long_description;
          prodDetailsObj.data.pricing = typeof prodDetailsObj.data.pricing == 'object' ? prodDetailsObj.data.pricing : JSON.parse(prodDetailsObj.data.pricing);
          if (prodDetailsObj.data.pricing && prodDetailsObj.data.pricing.length > 0) {
            let currencyVal = false;
            let data = {
              "currentLocation": this.currentLocation,
              "currency": this.getCurrency
            }
            prodDetailsObj.data.pricing.forEach(e => {
              if (data.currency && e.currency_type == data.currency && !currencyVal) {
                this.productPrice = Number(e.price);
                this.productCurrency = e.currency_type;
                currencyVal = true;
              } else if (data.currentLocation && data.currentLocation.currency && e.currency_type == data.currentLocation.currency.code && !currencyVal) {
                this.productPrice = Number(e.price);
                this.productCurrency = e.currency_type;
                currencyVal = true;
              }
            })
            if (!this.productPrice || !currencyVal) {
              this.productPrice = Number(prodDetailsObj.data.price);
              this.productCurrency = data.currency;
            }
          }
          // this.productPrice = prodDetailsObj.data.price;
          // this.productCurrency = prodDetailsObj.data.currency_type;
          if (prodDetailsObj.data.attributes && prodDetailsObj.data.attributes[0].attribute_name != "null") {
            this.prodAttributes = prodDetailsObj.data.attributes;

            const preselectedIds = (this.activatedRoute.snapshot.queryParamMap.get('attrs') || '').split(',');
            this.prodAttributes.forEach(element => {
              element.attributesList.forEach(att => {
                att['is_selected'] = preselectedIds.includes(String(att.value_id));
                if (att['is_selected']) {
                  element['selected_attr'] = att.value;
                }
              })

            });

          }

          this.prodLimitedInventry = prodDetailsObj.data.limited_inventory
          this.productInventry = prodDetailsObj.data.inventory;

          this.productShippingDetails = JSON.parse(prodDetailsObj.data.shipping_json);

          if (prodDetailsObj.data.media_url) {
            this.productImgs = prodDetailsObj.data.media_url
            this.mainImg = this.productImgs[0]
            this.productImgsLength = this.productImgs.length
          }


          let isSaleStartTimerRuning = false;

          if (prodDetailsObj.data.sale_start_date_time) {

            this.saleStartDate = prodDetailsObj.data.sale_start_date_time;

            this.startDate = moment.utc(this.saleStartDate, "YYYY-MM-DD HH:mm:ss").tz(this.timezoneVal).valueOf();
            this.totalSeconds = this.startDate ? (this.startDate - this.todayDate) : 0;


            if (this.totalSeconds > 0) {
              let startDateTime = moment.utc(this.saleStartDate, "YYYY-MM-DD HH:mm:ss").tz(this.timezoneVal);
              let end = moment.utc(startDateTime).local();
              this.saleStartOrEndDate = moment().format("ddd") + ", " + moment(end).format("DD MMM") + " " + moment(end).format("YYYY");
              isSaleStartTimerRuning = true
              this.hideBtns = true;
              this.showTimer = true;
              this.saleText = "Sale Starts In"
              this.startTimer();

            }


          }

          if (isSaleStartTimerRuning == false) {


            if (prodDetailsObj.data.sale_end_date_time) {

              this.saleEndDate = prodDetailsObj.data.sale_end_date_time;
              this.endDate = moment.utc(this.saleEndDate, "YYYY-MM-DD HH:mm:ss").tz(this.timezoneVal).valueOf();
              this.totalSeconds = this.endDate ? (this.endDate - this.todayDate) : 0;

              if (this.totalSeconds > 0) {
                let endDateTime = moment.utc(this.saleEndDate, "YYYY-MM-DD HH:mm:ss").tz(this.timezoneVal);
                let end = moment.utc(endDateTime).local();
                this.saleStartOrEndDate = moment().format("ddd") + ", " + moment(end).format("DD MMM") + " " + moment(end).format("YYYY");
                this.showTimer = true;
                this.hideBtns = false;
                this.saleText = "Sale Ending In"
                this.startTimer();
              }
            }

          }


          this.readMoreLess("less");
          if (this.finalProductDetails && this.finalProductDetails.data && this.finalProductDetails.data.is_digital == 0 && this.productShippingDetails && this.productShippingDetails.length > 0 && this.currentLocation && this.currentLocation.country_code2) {
            this.isShippingAvl = false;
            this.productShippingDetails.forEach(e => {
              if (e.country_name == this.currentLocation.country_code2) {
                this.isShippingAvl = true;
              }
            })
          } else {
            this.isShippingAvl = true;
          }
          this.updateProdViews(this.productId);

        }

      })
      .catch((error) => {
        this.ngxLoader.stop();
      });


  }

  updateProdViews(prodId) {


    let url = MERCH_API.UPDATE_PROD_VIEWS;
    let data = {
      product_id: prodId
    }
    this.appPaymentService.postRequest(url, data).subscribe(response => {



    }, error => {
      console.log(error, ":error");

    });
  }

  openCheckoutDialog(cartId) {

    let url = MERCH_API.GET_CART_PRODUCTS;
    this.appPaymentService.postRequest(url, { "cart_id": cartId }).subscribe(response => {
      let payload = {
        'cart_id': cartId,
        'cart_products': response.result,
        'organization_id': this.organizationId
      }
      if (response.status === 0) {
        const dialogRef = this.dialog.open(GotoCratdialogComponent, {
          width: '370px',
          panelClass: 'app-confirmation-dialog',
          data: payload
        });

      } else if (response.status === 1) {

        this.toaster.error(response.message)

      }
    }, error => {
      this.ngxLoader.stop();
      this.toaster.error(error)
    });

  }
  ngOnDestroy() {
    this.userInfoSubscription?.unsubscribe();
    this.settingsDataSubscription?.unsubscribe();
    this.routeChangeSubscription?.unsubscribe();
    clearTimeout(this.justAddedTimer);
  }
}